import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Expand from '@components/Icon/Expand'
import Collapse from '@components/Icon/Collapse'
import _ from 'lodash'

class AtheneumOfficeList extends Component {
  static propTypes = {
    teamStore: PropTypes.object
  }

  renderCollapseExpand (parent) {
    if (!parent.employees.length) return ''

    return parent.expanded ? (
      <Collapse
        onClick={() => {
          parent.expanded = false
        }}
      />
    ) : (
      <Expand
        onClick={() => {
          parent.expanded = true
        }}
      />
    )
  }

  renderNavLink (parent) {
    return (
      <p className='team--teams-panel-item--office'>
        {parent.name !== 'Unassigned' ? (
          parent.name
        ) : (
          <Link
            onClick={() =>
              this.props.teamStore.scrollToTeamName('unassigned-employees')
            }
            to='#unassigned-employees'
          >
            Unassigned Employees
          </Link>
        )}
      </p>
    )
  }

  renderTeams (parent) {
    if (parent.expanded) {
      let uniqueTeams = Array.from(
        parent.employees.reduce((teams, employee) => {
          return teams.add(employee.teamId)
        }, new Set())
      ).map(teamId => parent.employees.find(e => teamId === e.teamId))

      uniqueTeams = _.sortBy(uniqueTeams, ['accountManagerName', 'teamName'])

      return uniqueTeams.map(employee => {
        const teamName = employee.teamName.replace(/\s/g, '-')
        return (
          <div
            key={employee.teamId}
            className='team--teams-panel-item--teamname'
          >
            <Link
              onClick={() => this.props.teamStore.scrollToTeamName(teamName)}
              to={'#' + teamName}
            >
              {employee.accountManagerName} - {employee.teamName}
            </Link>
          </div>
        )
      })
    }
  }

  render () {
    const { atheneumOfficeList } = this.props.teamStore

    return (
      <div className='team--teams-panel--links'>
        {Object.keys(atheneumOfficeList)
          .sort()
          .map(officeName => {
            const parent = atheneumOfficeList[officeName]

            return (
              <div key={parent.id}>
                <div>
                  {this.renderCollapseExpand(parent)}
                  {this.renderNavLink(parent)}
                </div>
                {this.renderTeams(parent)}
              </div>
            )
          })}
      </div>
    )
  }
}

export default observer(AtheneumOfficeList)
